import { Component, OnDestroy } from '@angular/core';
import { AppSettings } from 'app/service/app-settings.service';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    standalone: false
})
export class Page404Component  implements OnDestroy {
    constructor(public appSettings: AppSettings) {
      this.appSettings.appEmpty = true;
    }
  
    ngOnDestroy() {
      this.appSettings.appEmpty = false;
    }
}
